import React, {useState} from 'react'
import NavBar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import TextField from '@mui/material/TextField';
import PagesFooter from '../components/PagesFooter';
import { ContactPageBody,ContactPageEmail,ContactPageHeader } from './pageElements';
import firebase from 'firebase/compat/app';
import { projectFirestore } from '../firebase/config';
import Box from '@mui/material/Box';
import { doc } from 'firebase/firestore';
import { Input } from '@mui/material';


const Contact = () =>  {
    const [isOpen, setIsOpen] = useState(false)

    const toggle =() =>{
     
      setIsOpen(!isOpen)
    };


    const handleSubmit = (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      console.log({
        title: data.get('title'),
        message: data.get('message'),
      });
  
      var docData = {
        title: data.get('title'),
        message: data.get('message'),
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      };

      if(data.get('message').length >1){
         projectFirestore.collection("Messages").doc().set(docData);
      
      alert("We'll get back to you as soon as possible, Giggity")
      document.getElementById('title').value = "";
      document.getElementById('message').value = "";
      } else{
        alert("Message can't  be blank")
      }
     

    };

    return (

      <body class="">

        <div class="wrapper">

          <Sidebar isOpen={isOpen} toggle={toggle}/>
            <NavBar toggle={toggle}/>

            <div class='container hero'>
              <h1>Get in touch.</h1>

            </div>
            <div>


            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>

                <TextField sx={{ mt: 5 }}
                  fullWidth
                  margin="normal"
                  id="title"
                  label="Title"
                  name="title"
                  variant="outlined"
                />
              
                <TextField
                  margin="normal"
                  fullWidth
                  required
                  multiline
                  minRows={4}
                  id="message"
                  label="Message"
                  variant="outlined"
                  name="message"
                />

                <button
                  className='submit-button'
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  SEND
                </button>
                </Box>
              

            </div>

            
          </div>

      </body>
       
    )
}

export default Contact
